export default __webpack_public_path__ + "src/assets/logo.a7c4191e2a345ee39a76a441305f8a74.png";